export enum FunctionNames {
  'default',
  'genFunctionParameters',
  'genSwitchParameters',
  'genCopyParameters',
  'genSetParameters',
  'genPushToResultArrayParameters',
  'genCheckInternetParameters',
  'genGetParameters',
  'genOpenURLParameters',
  'genResParameters',
  'genQRParameters',
  'genPostParameters',
  'genDownloadParameters',
  'genParseJSONParameters',
  'genEvents',
  'genElements',
  'genSplitStringParameters',
  'genGetConfigParameters',
  'genResURLParameters',
  'genMeasureParameters',
  'genFetchResultParams',
  'genExportResultsParameters',
  'genResultTableParameters',
  'genHashStringParameters',
  'genConnectScannerParameters',
  'genValidateCreditsParameters',
  'genFinalizeScannerParameters',
  'genIdentifyRevisionParameters',
  'genSaveResultsFilteredForExportParameters',
  'genSendGenericCommand',
  'genCheckObjectKeysParameters',
  'genWriteLogParameters',
}
